import React, { Component } from 'react'
import { Form, Button, Grid, GridRow,Input, Checkbox, GridColumn } from 'semantic-ui-react'
import { connect } from "react-redux";
import { addEntry } from "../redux/actions";
import { Redirect } from 'react-router-dom'
import GoogleAnalytics from 'react-ga'

const newEntry={id:'', date: new Date().toISOString().substr(0, 10), value:'', type: true, recipient: '', purpose: '', category: ''};

class EntryInputForm extends Component {
  
  state = {
    entry:{...newEntry},
    addMoreChecked:false,
    returnHome:false
  }


  handleSubmit = () => {
    const entry = this.state.entry;
    const more = this.state.addMoreChecked;
    
    if(entry.type)
    {
      entry.value = Math.abs(entry.value)*-1;
    }
    if(entry.date != ""){
      entry.date = new Date(entry.date);
    }
    if(entry.value != ""){
      entry.value = Number(entry.value);
    }

    console.log("new entry triggered");
    this.props.addEntry(entry);
    GoogleAnalytics.event({category: 'Entry', action: 'Added' });
    if(!more){
      this.setState({returnHome : true});
    }
    else{
      this.setState({entry :{...newEntry}});
    }
  }
  handleClose = () => this.setState({returnHome : true});
  checkedChanged=(e, { value })=>this.setState({addMoreChecked:!this.state.addMoreChecked});
  toggle = () => this.setState({ entry: {...this.state.entry, type: !this.state.entry.type }})
  handleInputChange = (e, { name, value }) => {
    console.log(name)
    console.log(value)
 
    this.setState({ entry:{...this.state.entry, [name]: value }})
  }
  
  render() {
    if(this.state.returnHome)
      return <Redirect to='/' />
    return (
    <Form onSubmit={this.handleSubmit}>
      <Form.Field control={Input} label="Datum" name="date" type='date' value={this.state.entry.date} width={8} fluid
      onChange={this.handleInputChange}></Form.Field>
      <Form.Field control={Input} label="Betrag" type='number' name="value" step='any' width={8} value={this.state.entry.value}
      onChange={this.handleInputChange}
      placeholder='123'></Form.Field>
      
      
      <Form.Field>
      <Form.Checkbox label="Ausgabe" name="type" onChange={this.toggle} checked={this.state.entry.type}></Form.Checkbox>
      </Form.Field>

      <Form.Field>
        <label>Empfänger</label>
        <Input type="text" name="recipient" width={8}
        onChange={this.handleInputChange} value={this.state.entry.recipient}
        placeholder="Empfängername" />
      </Form.Field>
      <Form.Field> 
        <label>Zweck</label>
        <Input type="text" name="purpose" width={8}
        onChange={this.handleInputChange} value={this.state.entry.purpose}
        placeholder="Kinokarten" />
      </Form.Field>
      <Form.Field>
        <label>Kategorie</label> 
        <Input type="text" name="category" width={8}
        onChange={this.handleInputChange} value={this.state.entry.category}
        placeholder="Geschenke" />

      </Form.Field>

      <Button onClick={this.handleClose}>Abbrechen</Button> <Button primary id="submit_button">Hinzufügen</Button>
      <Checkbox onChange={this.checkedChanged} checked={this.state.addMoreChecked} label="Weitere hinzufügen"></Checkbox>
      </Form>
    )
  }
}

export default connect(null,  { addEntry })(EntryInputForm);